import React, {
  useState,
  useEffect,
} from "react";

import "../styles/CustomerFeedback.css";

import {
  FaArrowLeft,
  FaArrowRight,
  FaStar,
} from "react-icons/fa";

const feedbacks = [

  {
    id: 1,

    name: "Rohit Sharma",

    role: "Mountain Rider",

    story:
      "The riding experience feels premium and powerful. SAC MTB completely changed my weekend adventures.",

    profile:
      "https://randomuser.me/api/portraits/men/32.jpg",

    image:
      "https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=1600",
  },

  {
    id: 2,

    name: "Aarohi Mehta",

    role: "Fitness Enthusiast",

    story:
      "My kids absolutely love the ride-on toys while I enjoy cycling every morning. Premium quality and stylish products.",

    profile:
      "https://randomuser.me/api/portraits/women/44.jpg",

    image:
      "https://images.unsplash.com/photo-1511994298241-608e28f14fde?q=80&w=1600",
  },

  {
    id: 3,

    name: "Kunal Verma",

    role: "Adventure Rider",

    story:
      "From customer support to ride quality, everything feels luxury. SAC MTB delivers a true riding lifestyle.",

    profile:
      "https://randomuser.me/api/portraits/men/76.jpg",

    image:
      "https://images.unsplash.com/photo-1507035895480-2b3156c31fc8?q=80&w=1600",
  },

];

const CustomerFeedback = () => {

  const [current, setCurrent] =
    useState(0);

  /* AUTO SLIDE */

  useEffect(() => {

    const interval = setInterval(() => {

      setCurrent((prev) =>
        (prev + 1) %
        feedbacks.length
      );

    }, 5000);

    return () =>
      clearInterval(interval);

  }, []);

  /* NEXT */

  const nextSlide = () => {

    setCurrent((prev) =>
      (prev + 1) %
      feedbacks.length
    );
  };

  /* PREV */

  const prevSlide = () => {

    setCurrent((prev) =>
      prev === 0
        ? feedbacks.length - 1
        : prev - 1
    );
  };

  return (

    <section className="feedback-section">

      {/* HEADER */}

      <div className="feedback-header">

        <span>
          CUSTOMER STORIES
        </span>

        <h2>

          Real Riders.
          <br />

          Real Adventures.

        </h2>

      </div>

      {/* SLIDER */}

      <div className="feedback-slider">

        {feedbacks.map((item, index) => (

          <div
            key={item.id}
            className={`feedback-slide ${
              index === current
                ? "active"
                : "inactive"
            }`}
          >

            {/* BG IMAGE */}

            <img
              src={item.image}
              alt={item.name}
              className="feedback-bg"
            />

            {/* OVERLAY */}

            <div className="feedback-overlay">

              {/* PROFILE */}

              <div className="feedback-profile">

                <img
                  src={item.profile}
                  alt={item.name}
                />

                <div>

                  <h3>
                    {item.name}
                  </h3>

                  <p>
                    {item.role}
                  </p>

                </div>

              </div>

              {/* STARS */}

              <div className="feedback-stars">

                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />

              </div>

              {/* STORY */}

              <p className="feedback-story">

                “{item.story}”

              </p>

            </div>

          </div>

        ))}

      </div>

      {/* CONTROLS */}

      <div className="feedback-controls">

        <button
          onClick={prevSlide}
        >

          <FaArrowLeft />

        </button>

        <button
          onClick={nextSlide}
        >

          <FaArrowRight />

        </button>

      </div>

    </section>
  );
};

export default CustomerFeedback;